<template>
  <div class="mobiluce-wrapper">
    <el-container>
      <app-main />
    </el-container>
  </div>
</template>
<script>
import { AppMain } from "./components";

export default {
    name: "MobiluceLayout",
    components: {
        AppMain,
    },
};
</script>
<style>
/* Classe propre au layout Mobiluce : `app-wrapper` est la racine de Layout.vue,
   et ce bloc n'est pas scopé — il bornait toute l'application intranet à 100vh
   et deplacait son scroll sur les `el-container`, coupant les ecrans longs. */
.mobiluce-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
}
.mobiluce-wrapper .el-container {
  flex: 1;
  width: 100%;
  overflow: auto;
}
</style>
